import React, { useMemo } from 'react';
import clsx from 'clsx';
import Typography from '~/shared/components/Typography/Typography';
import styles from './ProfileHeader.module.scss';

export type ProfileHeaderProps = {
    title: string;
    subtitle?: string;
    earnnedPoints?: number;
};

const ProfileHeader: React.FC<ProfileHeaderProps> = ({ title, subtitle, earnnedPoints }) => {
    const formattedAmount = useMemo(() => {
        if (earnnedPoints == null) {
            return null;
        }

        return new Intl.NumberFormat('da-DK', {
            maximumFractionDigits: 0,
        }).format(earnnedPoints);
    }, [earnnedPoints]);

    return (
        <header
            className={clsx(styles.heading, {
                [styles.headingUnderlined]: formattedAmount != null,
            })}
        >
            <div>
                <Typography variant="title-M" as="h1">
                    {title}
                </Typography>
                <Typography variant="paragraph-M" as="p">
                    {subtitle}
                </Typography>
            </div>
            {formattedAmount != null && (
                <div className={styles.earnedPoints}>
                    <Typography
                        variant="paragraph-M"
                        as="span"
                        className={styles.earnedPointsTitle}
                    >
                        Optjent
                    </Typography>
                    <Typography variant="title-L" as="span" className={styles.earnedPointsValue}>
                        {formattedAmount}
                    </Typography>
                    <Typography variant="paragraph-M" as="span">
                        kr.
                    </Typography>
                </div>
            )}
        </header>
    );
};

export default ProfileHeader;
